﻿export const accordionCollapsible = (elem, onToggled) => {
    const trigger = elem.querySelector(".collapsible");
    const activeAttribute = "active";
    function handleClick() {
        var shouldClose = trigger.getAttribute(activeAttribute) !== null;
        if (shouldClose) {
            close();
        } else {
            trigger.setAttribute(activeAttribute, '');
        }
        if (typeof onToggled === "function") {
            onToggled({ isOpen: !shouldClose });
        }
    }
    function close() {
        trigger.removeAttribute(activeAttribute);
    }
    trigger.addEventListener("click", handleClick);
    return {
        close: close
    };
};